import { httpClient } from '@/utils/http'
export class VipAPI {
  static async getVipPerks(): Promise<any> {
    return httpClient.post<any>('/getVipPerks')
  }
  static async getSubscribePackagesCount(data: any): Promise<any> {
    return httpClient.post<any>('/buySubPkg', data)
  }
}
